// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Qi42","errorLogs":"EditorFooter_errorLogs__3r3dH"};